import ProductShipFromModal from './ProductShipFromModal';

export default ProductShipFromModal;
